export const database = "https://netflix-crf-2022-backend.herokuapp.com";
export const database_prod = "http://localhost:5500";
export const database_r6g = "https://r6g-game-back.onrender.com";
export const database_stitch = "https://stitch-2022-backend.herokuapp.com";
export const database_marvel = "https://marvel-tdo-back.herokuapp.com";
export const database_marvel_en = "https://marvel-tdo-en-back.herokuapp.com";
